<template>
  <div>
    <v-card class="py-3 px-3 mb-5">
      <div>
        <h4 class="text-uppercase mb-3">
          {{ $vuetify.lang.t('$vuetify.labels.info') }}
        </h4>
        <table v-if="order">
          <tr>
            <td class="font-weight-bold">
              {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.created') }}
            </td>
            <td class="pl-3">
              {{ formatDateTime(order.createdAt) }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">
              {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.brought') }}
            </td>
            <td class="pl-3">
              {{ formatDateTime(order.bringTo) }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">
              {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.updated') }}
            </td>
            <td class="pl-3">
              {{ formatDateTime(order.updatedAt) }}
            </td>
          </tr>
        </table>
      </div>
    </v-card>
  </div>
</template>

<script>
import {formatDateTime} from "@/common/helpers/date";

export default {
  props: {
    order: {
      type: Object,
      default: null,
    },
  },

  methods: {
    formatDateTime,
  }
};
</script>
